'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  background-color: ', ';\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  box-sizing: border-box;\n  font-family: Roboto, sans-serif;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  border-radius: 2px;\n  z-index: 1;\n'], ['\n  color: ', ';\n  background-color: ', ';\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  box-sizing: border-box;\n  font-family: Roboto, sans-serif;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  border-radius: 2px;\n  z-index: 1;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 16px;\n  position: relative;\n'], ['\n  padding: 16px;\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  color: ', ';\n  display: block;\n}\n'], ['\n  font-size: 14px;\n  color: ', ';\n  display: block;\n}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 28px;\n  color: ', ';\n  display: block;\n  line-height: 36px;\n  font-weight: bold;\n'], ['\n  font-size: 28px;\n  color: ', ';\n  display: block;\n  line-height: 36px;\n  font-weight: bold;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  padding: 16px;\n  font-size: 14px;\n  color: ', ';\n'], ['\n  padding: 16px;\n  font-size: 14px;\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Card = _styledComponents2.default.div(_templateObject, _color2.default.black, _color2.default.white);

var CardTitleContainer = _styledComponents2.default.div(_templateObject2);

var CardSubTitle = _styledComponents2.default.span(_templateObject3, _color2.default.grey_accent_1);

var CardTitle = _styledComponents2.default.span(_templateObject4, _color2.default.black);

var CardText = _styledComponents2.default.div(_templateObject5, _color2.default.black);

var MozartScoreCard = function (_Component) {
  _inherits(MozartScoreCard, _Component);

  function MozartScoreCard() {
    _classCallCheck(this, MozartScoreCard);

    return _possibleConstructorReturn(this, (MozartScoreCard.__proto__ || Object.getPrototypeOf(MozartScoreCard)).apply(this, arguments));
  }

  _createClass(MozartScoreCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          containerStyle = _props.containerStyle,
          titleStyle = _props.titleStyle,
          subTitleStyle = _props.subTitleStyle,
          themeId = _props.themeId;

      return _react2.default.createElement(
        Card,
        { style: containerStyle, 'data-qa': this.props.testId, 'data-theme': themeId },
        _react2.default.createElement(
          CardTitleContainer,
          null,
          this.props.title && _react2.default.createElement(
            CardTitle,
            { style: titleStyle },
            this.props.title
          ),
          this.props.subtitle && _react2.default.createElement(
            CardSubTitle,
            { style: subTitleStyle },
            this.props.subtitle
          )
        ),
        this.props.text && _react2.default.createElement(
          CardText,
          null,
          this.props.text
        )
      );
    }
  }]);

  return MozartScoreCard;
}(_react.Component);

MozartScoreCard.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  title: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  containerStyle: _propTypes2.default.object,
  titleStyle: _propTypes2.default.object,
  subTitleStyle: _propTypes2.default.object,
  text: _propTypes2.default.object
};
MozartScoreCard.defaultProps = {
  testId: 'MozartScoreCard',
  themeId: 'MozartScoreCard',
  subtitle: '',
  containerStyle: {},
  titleStyle: {}
};
exports.default = MozartScoreCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartStatBox/MozartScoreCard/MozartScoreCard.js
// module id = 2114
// module chunks = 1